import { useCallback, useMemo, useState } from 'react';
import { Button, Form } from 'shards-react';
import ConfirmPasswordField from './ConfirmPasswordField';
import NewPasswordField from './NewPasswordField';
import OldPasswordField from './OldPasswordField';
import useFetch from 'utils/hooks/useFetch';
import Loading from 'components/Loading';
import AlertMessage from 'components/AlertMessage';

const PasswordUpdater = () => {
  const isEmpty = useCallback((val) => val === '', []);
  const [oldPassword, setOldPassword] = useState(() => '');
  const isOldPassEmpty = isEmpty(oldPassword);
  const [newPassword, setNewPassword] = useState(() => '');
  const isNewPassEmpty = isEmpty(newPassword);
  const [confirmPassword, setConfirmPassword] = useState(() => '');
  const isConfirmPassValid = useMemo(() => !isNewPassEmpty && newPassword === confirmPassword, [isNewPassEmpty, newPassword, confirmPassword]);
  const isNewPassUnique = useMemo(() => oldPassword !== newPassword, [oldPassword, newPassword]);

  const [passwordScore, setPasswordScore] = useState(() => null);
  const { status, data, fetchData } = useFetch({ method: 'POST', url: '/settings/update-password', immediate: false });
  const isLoading = useMemo(() => status === 'fetching', [status]);

  const isDisabled = useMemo(() => isLoading || isOldPassEmpty || !isNewPassUnique || !isConfirmPassValid || passwordScore < 2, [isLoading, isOldPassEmpty, isNewPassUnique, isConfirmPassValid, passwordScore]);

  const updatePasswort = useCallback(
    (e) => {
      e.preventDefault();
      if (isDisabled) return null;
      return fetchData({ data: { oldPassword, newPassword } });
    },
    [isDisabled, fetchData, oldPassword, newPassword]
  );

  return (
    <Form className='p-3' autoComplete='off' onSubmit={updatePasswort}>
      {status === 'error' && <AlertMessage alertMessage='Bitte überprüfen Sie Ihre Zugangsdaten und versuchen Sie es erneut.' autoDismiss={true} />}
      {data === 'OK' && <AlertMessage alertMessage='Das Passwort wurde erfolgreich aktualisiert!' background='success' />}
      <OldPasswordField oldPassword={oldPassword} setOldPassword={setOldPassword} isEmpty={isOldPassEmpty} />
      <NewPasswordField newPassword={newPassword} setNewPassword={setNewPassword} passwordScore={passwordScore} setPasswordScore={setPasswordScore} isNewPassUnique={isNewPassUnique} />
      <ConfirmPasswordField confirmPassword={confirmPassword} setConfirmPassword={setConfirmPassword} isConfirmPassValid={isConfirmPassValid} />
      <Button outline={isLoading} type='submit' disabled={isDisabled}>
        {isLoading ? <Loading /> : 'Passwort aktualisieren'}
      </Button>
    </Form>
  );
};

export default PasswordUpdater;
